import classNames from "classnames";
import React, { ComponentPropsWithRef, forwardRef, useRef } from "react";
import { mergeRefs } from "use-callback-ref";
import "./transparent-button.css";

interface TransparentButtonProps extends ComponentPropsWithRef<"button"> {
	/** Disable hover effect */
	noHover?: boolean;
}

/** A standard button with a transparent background and no border */
export const TransparentButton = forwardRef<HTMLButtonElement, TransparentButtonProps>(
	({ children, className, noHover, ...props }, ref) => {
		const innerRef = useRef<HTMLButtonElement>(null);

		return (
			<button
				type="button"
				ref={mergeRefs([ref, innerRef])}
				className={classNames([
					"transparent-button",
					className,
					{ "transparent-button--no-hover": noHover },
				])}
				{...props}
			>
				{children}
			</button>
		);
	},
);

TransparentButton.displayName = "TransparentButton";
